import { useEffect } from 'react';
import { logoArtwork } from '../data/logoArtwork';
import { hero, site } from '../data/site';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Title, description, and social tags. */
export function useDocumentMeta() {
  useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = site.name;
    upsertMeta('name', 'description', hero.headline);
    upsertMeta('name', 'theme-color', '#F6F5F1');
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', site.name);
    upsertMeta('property', 'og:title', site.name);
    upsertMeta('property', 'og:description', hero.headline);
    upsertMeta('property', 'og:image', logoArtwork.src);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', site.name);
    upsertMeta('name', 'twitter:description', hero.headline);
  }, []);
}
